import { render, staticRenderFns } from "./SubCompany.vue?vue&type=template&id=7b89416b&"
import script from "./SubCompany.vue?vue&type=script&lang=js&"
export * from "./SubCompany.vue?vue&type=script&lang=js&"
import style0 from "./SubCompany.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports